<template>
  <Modal
    :title="title"
    no-footer
    class-name="equipment-capture-modal"
    @hide-modal="$emit('hide-modal')"
  >
    <div>
      <div
        class="d-flex justify-content-between align-items-center mb-2 font-bold"
      >
        {{ fullAddress(address) }}
        <EquipmentIconsLegend />
      </div>
      <div>
        <LineItemEquipmentRequest
          v-for="item in lineItems"
          :key="item.id"
          :line-item="item"
          :equipment="customerEquipment"
          class="mb-4"
          :address="address"
          :customer="customer"
          @refresh-invoice="$emit('refresh-invoice')"
          @refresh-equipment="$emit('refresh-equipment')"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapState } from "vuex";

import Modal from "@/components/Modal.vue";
import { fullAddress } from "@/mixins";
import LineItemEquipmentRequest from "./LineItemEquipmentRequest.vue";

export default {
  components: {
    Modal,
    LineItemEquipmentRequest
  },
  props: {
    address: {
      type: Object,
      default: () => ({})
    },
    invoice: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ["hide-modal", "refresh-invoice", "refresh-equipment"],
  data() {
    return {
      equipmentModal: false
    };
  },
  computed: {
    ...mapState(["equipmentTypes", "customerEquipment", "currentUser"]),
    title() {
      return `Invoice #${this.invoice?.invoice_id} Equipment`;
    },
    customer() {
      return {
        ...this.invoice.customer,
        id: this.invoice.customer.customer_id
      };
    },
    lineItems() {
      return this.invoice.items_attributes.reduce((lineItems, lineItem) => {
        if (Object.prototype.hasOwnProperty.call(lineItem, "items_in_group")) {
          lineItems = lineItems.concat(lineItem.items_in_group);
          return lineItems;
        }
        lineItems.push(lineItem);
        return lineItems;
      }, []);
    }
  },
  mounted() {
    this.fetchEquipmentTypes();
    this.fetchCustomerEquipment({
      link:
        this.customer?.links?.fetch_equipment ||
        this.currentUser.links.fetch_equipment,
      addressId: this.address.id
    });
  },
  methods: {
    ...mapActions(["fetchEquipmentTypes", "fetchCustomerEquipment"]),
    fullAddress
  }
};
</script>

<style lang="scss" scoped>
.equipment-capture-modal {
  .modal-dialog {
    width: 100%;
    max-width: 1024px !important;
  }
}
::v-deep .btn {
  font-size: 1em;
  border-radius: var(--sera-border-radius) !important;
  box-shadow: none;
}
</style>
